/* src/app/layouts/unauthenticated/unauthenticated.component.css */
.mobile {
  display: none;
}
.not-mobile {
  display: block;
}
@media screen and (max-width: 500px) {
  .mobile {
    display: block;
  }
  .not-mobile {
    display: none;
  }
}
/*# sourceMappingURL=unauthenticated.component-BIRY4UZI.css.map */
